import React from "react";
import { useParams } from "react-router-dom";
import RGA_report from "./ReportItems/RGA_report";
import InitialContactReport from "./ReportItems/InitialContactReport";
import ActiveClientsReport from "./ReportItems/ActiveClientsReport";
import B2BReferralsReport from "./ReportItems/B2BReferralsReport";
import WebIntakeReport from "./ReportItems/WebIntakeReport";
import ResourcePartnerReport from "./ReportItems/ResourcePartnerReport";
import GeneralClientReport from "./ReportItems/GeneralClientReport";
import ClientDemographicsReport from "./ReportItems/ClientDemographicsReport";
import EngagementOperationsReport from "./ReportItems/EngagementOperationsReport";

const Report = () => {
  const { id } = useParams();

  if (id === "rga") {
    return <RGA_report />;
  } else if (id === "initial_contact") {
    return <InitialContactReport />;
  } else if (id === "active_clients") {
    return <ActiveClientsReport />;
  } else if (id === "b2b_referrals") {
    return <B2BReferralsReport />;
  } else if (id === "webintake") {
    return <WebIntakeReport />;
  } else if (id === "resource_referrals") {
    return <ResourcePartnerReport />;
  } else if (id === "general_client") {
    return <GeneralClientReport />;
  } else if (id === "client_demographics") {
    return <ClientDemographicsReport />;
  } else if (id === "engagement_operations") {
    return <EngagementOperationsReport />;
  } else {
    return <>No matching Report found</>;
  }
};

export default Report;
